const translations = {
  takePicture: 'Take picture',
  reset: 'Reset',
};

export default translations;
